/* @flow */
// typecheck: ignore file
import React from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import Tabs from 'components/Tabs.jsx';
import TabPanel from 'components/TabPanel.jsx';

import './styles/DistrictLayout.scss';

type Props = {
  children: any,
  paid: ?boolean,
  params: { districtId: number },
}

class DistrictLayout extends React.Component {
  props: Props;

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  goSchools = () => {
    this.context.router.push(`/admin/districts/${this.props.params.districtId}/schools`);
  }

  goBilling = () => {
    this.context.router.push(`/admin/districts/${this.props.params.districtId}/billing`);
  }

  onTabChange = (index: number) => {
    [this.goSchools, this.goBilling][index]();
  }

  render() {
    const schools = !!this.context.router.location.pathname.match(/districts\/[0-9]+\/schools/);

    return (
      <div className="DistrictLayout">
        {this.props.paid &&
          <div className="DistrictLayout-tabs">
            <Tabs tabActive={schools ? 0 : 1} onTabChange={this.onTabChange}>
              <TabPanel title={<span>Schools</span>} />
              <TabPanel title={<span>Billing</span>} />
            </Tabs>
          </div>
        }
        {this.props.children}
      </div>
    );
  }
}

const withOrganization = graphql(gql`
  query($organizationId: Int) {
    organizations(ids: [$organizationId]) {
      id
      paid
    }
  }`,
  {
    options: ({ params }) => ({
      variables: { organizationId: [params.districtId] },
    }),
    props: ({ data }) => ({
      paid: data.organizations ? data.organizations[0].paid : null,
    }),
  }
);

export { DistrictLayout };
export default withOrganization(DistrictLayout);



// WEBPACK FOOTER //
// ./src/admin/components/DistrictLayout.jsx